module.exports = __webpack_public_path__ + "static/media/patient5.185936f9.jpg";